"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BasePlayer2 = _interopRequireDefault(require("../BasePlayer"));
var _extractPlayablesFromConfig = _interopRequireDefault(require("../utils/extractPlayablesFromConfig"));
var _AdUtils = require("./AdUtils");
var _registry = _interopRequireDefault(require("../../utils/registry"));
var _VideoTimeHelpers = _interopRequireDefault(require("../utils/VideoTimeHelpers"));
var _ActivityTrackingUtils = require("../utils/ActivityTrackingUtils");
var _PlayablesUtils = _interopRequireDefault(require("./PlayablesUtils"));
var _TheoQualityHelper = require("./TheoQualityHelper");
var _theoplayer = _interopRequireDefault(require("./theoplayer.config"));
var _youbora = require("./youbora.config");
var _Mp4Preloader = _interopRequireDefault(require("../utils/preloader/Mp4Preloader"));
var _QualityUtils = require("../utils/QualityUtils");
var _listeners = require("./listeners");
var _theoplayer2 = _interopRequireDefault(require("./resources/theoplayer.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// eslint-disable-line no-unused-vars

var REWIND_BAIL_THRESHOLD = 0.01;
var REWIND_LOG_THRESHOLD = 30;
var EVENTS = {
  TIMEUPDATE: 'timeupdate',
  QUALITYCHANGED: 'qualitychanged'
};
var CONTENT_TYPE_HLS = 'application/x-mpegURL';
var CONTENT_TYPE_MP4 = 'video/mp4';
var THEO_VERSION = _theoplayer["default"].version;
var THEO_PLAYER_NAME = 'THEO';

/**
 * Class for the THEOplayer that implements the relevant methods from the
 * {BasePlayer} class.
 * @class TheoWrapper
 * @extends {BasePlayer}
 */
var TheoWrapper = exports["default"] = /*#__PURE__*/function (_BasePlayer) {
  /**
   * Create an instance of the TheoWrapper.
   * @param {InternalPlayerConfig} config - The player configuration object
   */
  function TheoWrapper(config) {
    var _this;
    _classCallCheck(this, TheoWrapper);
    _this = _callSuper(this, TheoWrapper, [config]);
    _defineProperty(_this, "_qualities", (0, _QualityUtils.qualitiesRecord)());
    _defineProperty(_this, "_playerState", {
      initialized: false,
      hideSpinner: false,
      drift: 0,
      playStartClockTime: 0,
      playStartTheoTime: 0
    });
    _defineProperty(_this, "_playables", {
      sources: [],
      index: 0,
      previousIndex: undefined,
      selectedAngleName: ''
    });
    _defineProperty(_this, "_desiredInitialRendition", _TheoQualityHelper.INITIALRENDITION.DEFAULT);
    _defineProperty(_this, "_youboraPlugin", null);
    _defineProperty(_this, "_compatibilityTester", null);
    _defineProperty(_this, "_youboraAdapter", null);
    _defineProperty(_this, "_hideSpinnerInterval", null);
    _defineProperty(_this, "_preloader", null);
    _defineProperty(_this, "updatePlayerSource", function (srcUri, contentType) {
      var _this$rawPlayer$sourc;
      var typedSource = {
        src: srcUri,
        type: contentType
      };
      // Only update source if it has changed
      var currentSource = (_this$rawPlayer$sourc = _this.rawPlayer.source) === null || _this$rawPlayer$sourc === void 0 ? void 0 : _this$rawPlayer$sourc.sources[0].src;
      // Allow resetting source if current source and new source are both `undefined`. This
      // doesn't feel *necessary* logically, but it appears to trigger events that VSPA relies on
      // when initializing playback. It also doesn't affect seamless playback (the black frame issue) because there
      // is no loaded content to interrupt.
      var setSource = currentSource === undefined || currentSource !== srcUri;
      if (setSource) {
        _this.rawPlayer.source = {
          sources: [typedSource],
          initialRendition: _this._desiredInitialRendition
        };
        _this._buffer = {
          start: 0,
          end: 0,
          percent: 0
        };
      } else {
        _listeners.onPlay.call(_this, {
          type: 'play'
        });
        _listeners.onDurationChange.call(_this, {
          type: 'durationchange'
        });
        _this.setStartTimeForPlayable();
        var _this$rawPlayer = _this.rawPlayer,
          currentTime = _this$rawPlayer.currentTime,
          readyState = _this$rawPlayer.readyState;
        // If the playable is dynamic we do not need to log canplay and playing events
        if (_this._isPlayableDynamic) {
          return;
        }
        _listeners.onCanPlay.call(_this, {
          type: 'canplay',
          currentTime: currentTime,
          readyState: readyState
        });
        _listeners.onPlaying.call(_this, {
          type: 'playing',
          currentTime: currentTime
        });
      }
      _this._preloader.queuePreloadsFromIndex(_this.playingIndex);

      // See onDurationChange event listener for actions performed after player loads new source, such as setting currentTime
    });
    _defineProperty(_this, "resetPlaybackRateState", function () {
      _this._stopRewinding();
      _this.logger.sendLog({
        func: 'Rewind',
        bufferEmpty: true,
        playbackRate: _this.playbackRate,
        stallCount: 1
      });
      _this.playbackRate = 1;
    });
    /* To enable rewind, for each "frame" when playing backwards,
     * we set the currentTime to a lower time and pause the player
     * because true reverse play is not supported yet
     */
    _defineProperty(_this, "setNewTime", function (newTime) {
      if (_this._rewind.interval) {
        _this._rewind.oldSeekTime = _this._rewind.newSeekTime;
        _this._rewind.newSeekTime = newTime;
        _this.rawPlayer.pause();
        _this.currentTime = newTime;
      }
    });
    /* because theoplayer doesn't currently support rewind, we have to fake it
    * so, every INTERVAL_RATE ms, we set the player time back by an amount
    * which is calculated based on the current rewind rate
    *
    * This method handles calculating the step rate, ensuring we can rewind,
    * and setting the new player time
    */
    _defineProperty(_this, "_doRewindStep", function () {
      var _this$_rewind = _this._rewind,
        lastPlayerTime = _this$_rewind.lastPlayerTime,
        startTime = _this$_rewind.startTime,
        logged = _this$_rewind.logged,
        initialStep = _this$_rewind.initialStep,
        playableStartTime = _this$_rewind.playableStartTime;
      var _this2 = _this,
        currentTime = _this2.currentTime;
      if (_this.rawPlayer.seeking && lastPlayerTime !== currentTime) {
        _this._rewind.lastPlayerTime = currentTime;
        // Dropped rewind frame, probably outside buffered range
        return;
      }
      var rewindTotal = startTime - currentTime;
      if (!logged && rewindTotal >= REWIND_LOG_THRESHOLD) {
        _this.logger.sendLog({
          func: 'Rewind',
          playbackRate: _this.playbackRate,
          thresholdReached: true
        });
        _this._rewind.logged = true;
      }
      if (currentTime >= REWIND_BAIL_THRESHOLD) {
        var newTime = Math.max(currentTime - _this._rewind.rate * 0.08, 0);
        var newRawTime = playableStartTime + newTime;
        // Ensure the time we want to seek to is buffered
        if (!_this._hasBufferForRewind(newRawTime)) {
          // Pause rewind until we have more video buffered
          return;
        }
        if (initialStep) {
          _this._rewind.initialStep = false;
          //hide the loading spinner
          _this.hideSpinner = true;
        }
        _this.setNewTime(newTime);
      } else {
        // stop rewinding, we're too close to the beginning of the video
        _this.resetPlaybackRateState();
      }
    });
    _this.logger.times.LoadTimeInit = performance.now();
    _this._playerState.autoQuality = (0, _QualityUtils.isHLS)(config.playables && config.playables[0].src);
    _this._playables.sources = (0, _extractPlayablesFromConfig["default"])(config.playables, window.location, _AdUtils.getPlayableAds);
    _this._rewind = {
      rate: null,
      interval: null,
      logged: false,
      startTime: null,
      lastPlayerTime: null,
      playableStartTime: null
    };
    _this._buffer = {
      start: 0,
      end: 0,
      percent: 0
    };
    _this._insert = _PlayablesUtils["default"].insert.bind(_this);
    _this._remove = _PlayablesUtils["default"].remove.bind(_this);
    _this._push = _PlayablesUtils["default"].push.bind(_this);
    // needed for BasePlayer._emitTimeUpdate
    _this._onEnded = _listeners.onEnded.bind(_this);
    _this._preloader = new _Mp4Preloader["default"](_this.config.preloaderConfig, _this.logger);
    _this._preloader.setPlayables(_this._playables.sources);
    _this.addEventListener('bufferedpercent', _this._preloader.playerBufferedPercentCallback.bind(_this._preloader));

    // Overrides the default license URL if one is provided in the config
    if (config.theoLicenseUrl) {
      _theoplayer["default"].licenseUrl = config.theoLicenseUrl;
    }
    return _this;
  }
  _inherits(TheoWrapper, _BasePlayer);
  return _createClass(TheoWrapper, [{
    key: "destroy",
    value: function destroy() {
      this._stopRewinding();
      clearTimeout(this._liveStatusPollTimeout);
      if (this._youboraPlugin) {
        this._youboraPlugin.removeAdapter();
      }
      if (this.activityTracker) {
        this._cleanupActivityTracking();
      }
      if (this._compatibilityTester) {
        this._cleanupCompatibilityTestListener();
      }
      this._playerState.initialized = false;
      if (this.rawPlayer && this.rawPlayer.destroy) {
        this.rawPlayer.destroy();
      } else {
        this._destroyedBeforeCreated = true;
      }

      // delete the wrapping dom node
      var wrapper = this.getVideoContainer();
      if (wrapper && wrapper.parentElement) {
        wrapper.parentElement.removeChild(wrapper);
      }

      // remove player from registry
      delete _registry["default"].theo.players[this.id];
    }
  }, {
    key: "bindPlayerEvents",
    value: function bindPlayerEvents() {
      var _this3 = this;
      this.rawPlayer.addEventListener('canplay', _listeners.onCanPlay.bind(this));
      this.rawPlayer.addEventListener('ended', this._onEnded);
      this.rawPlayer.addEventListener('error', _listeners.onError.bind(this));
      this.rawPlayer.addEventListener('loadeddata', _listeners.onLoadedData.bind(this));
      this.rawPlayer.addEventListener('loadedmetadata', _listeners.onLoadedMetadata.bind(this));
      this.rawPlayer.addEventListener('pause', _listeners.onPause.bind(this));
      this.rawPlayer.addEventListener('play', _listeners.onPlay.bind(this));
      this.rawPlayer.addEventListener('playing', _listeners.onPlaying.bind(this));
      this.rawPlayer.addEventListener('seeked', _listeners.onSeeked.bind(this));
      this.rawPlayer.addEventListener('seeking', _listeners.onSeeking.bind(this));
      this.rawPlayer.addEventListener('waiting', _listeners.onWaiting.bind(this));
      this.rawPlayer.addEventListener('timeupdate', _listeners.onTimeUpdate.bind(this));
      this.rawPlayer.addEventListener('durationchange', _listeners.onDurationChange.bind(this));
      this.rawPlayer.videoTracks.addEventListener('addtrack', _listeners.onVideoAddTrack.bind(this));
      this.rawPlayer.videoTracks.addEventListener('removetrack', _listeners.eventReemitter.call(this, 'removetrack'));

      // simple re-emitters
      ['fileskipped', 'filequeued', 'filepreloaded', 'filepreloading'].forEach(function (eventName) {
        _this3._preloader.addEventListener(eventName, _listeners.eventReemitter.call(_this3, eventName));
      });
      ['canplaythrough', 'contentprotectionerror', 'contentprotectionsuccess', 'destroy', 'durationchange', 'encrypted', 'presentationmodechange', 'progress', 'ratechange', 'readystatechange', 'representationchange', 'segmentnotfound', 'sourcechange', 'volumechange'].forEach(function (eventName) {
        _this3.rawPlayer.addEventListener(eventName, _listeners.eventReemitter.call(_this3, eventName));
      });
      ['adbegin', 'adend', 'aderror', 'adbreakbegin', 'adbreakend', 'adskip'].forEach(function (eventName) {
        _this3.rawPlayer.ads.addEventListener(eventName, _listeners.eventReemitter.call(_this3, eventName));
      });
    }
  }, {
    key: "_onPlayerLoaded",
    value: function _onPlayerLoaded() {
      var _this4 = this;
      // this will prevent creation if we are destroyed
      // before the player is loaded
      if (this._destroyedBeforeCreated) {
        return;
      }
      this.logger.times.LoadTimeInit = performance.now() - this.logger.times.LoadTimeInit;
      this.logger.times.LoadTimeVideo = -1;
      this.logger.logTime('LoadTime-Init', this.logger.times.LoadTimeInit);
      if (this.config.autoplay === true) {
        this.logger.times.LoadTimeVideo = performance.now();
      }

      // create Youbora plugin as early as possible
      var youbora = _registry["default"].theo.youbora;
      var mergedYouboraOptions = Object.assign({}, _youbora.youboraOptions, this.config.youboraOptions);
      if (youbora && youbora.Plugin && youbora.adapters && youbora.adapters.TheoPlayer2 && this.config.youboraOptions && mergedYouboraOptions.enabled === true && mergedYouboraOptions.accountCode) {
        (0, _youbora.sanitizeCustomYouboraDimensions)(mergedYouboraOptions);
        this._youboraPlugin = new youbora.Plugin(mergedYouboraOptions);
      }
      var config = Object.assign({}, _theoplayer["default"]);
      // Set ads from the first video only
      // TODO: allow per-playable ads
      if (this._playables.sources && this._playables.sources.length) {
        config.ads = this._playables.sources[0].ads;
      }
      var container = this.getVideoContainer();
      // Necessary for video.js styling and our styling to cooperate.
      container.className += ' video-js';
      var theoplayer = window.THEOplayer;
      this.rawPlayer = theoplayer.Player(container, config);
      // `controls` is undocumented. It disables control interactability, but does not hide them.
      this.rawPlayer.controls = false;
      this.rawPlayer.preload = this.config.preload || 'auto';
      this.autoplay = this.config.autoplay === true;
      // Don't re-set muted to false, as it will overwrite localstorage preference
      if (this.config.muted === true) {
        this.muted = true;
      }
      if (this.config.hardQualitySwitchingEnabled !== false) {
        this.rawPlayer.abr.clearBufferWhenSettingTargetQuality = true;
      }
      if (this._youboraPlugin) {
        this._youboraAdapter = new youbora.adapters.TheoPlayer2(this.rawPlayer);
        this._youboraPlugin.setAdapter(this._youboraAdapter);
      }
      if (this._playables.sources && this._playables.sources.length) {
        var firstItem = this._playables.sources[0];
        if (!this.config.autoplay) {
          this.rawPlayer.poster = firstItem.poster;
        }
      }
      this.bindPlayerEvents();
      this.src = this.currentPlayable && this.currentPlayable.src;
      this._playerState.initialized = true;
      setTimeout(function () {
        _this4.emit('initialized', null);
      }, 0);
    }
  }, {
    key: "_timeUpdated",
    value: function _timeUpdated() {
      if (this._playerState && this.currentTime !== 0) {
        if (this._playerState.playStartClockTime === 0) {
          this._playerState.drift = 0;
          this._playerState.playStartClockTime = performance.now();
          this._playerState.playStartTheoTime = this.currentTime;
        } else {
          var elapsedClockTime = performance.now() - this._playerState.playStartClockTime;
          var elapsedTheoTime = (this.currentTime - this._playerState.playStartTheoTime) * 1000;
          this._playerState.drift = elapsedClockTime * this.playbackRate - elapsedTheoTime;
        }
      }
    }
  }, {
    key: "version",
    get: function get() {
      return THEO_VERSION;
    }
  }, {
    key: "name",
    get: function get() {
      return THEO_PLAYER_NAME;
    }
  }, {
    key: "play",
    value: function play() {
      if (this._rewind.rate !== null) {
        this._startRewinding();
        return;
      }
      this._stopRewinding();
      this.rawPlayer.play();
      if (this._playerState.goToStart) {
        this._playerState.goToStart = false;
        this.setStartTimeForPlayable();
      }
      this.rawPlayer.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      this._stopRewinding();
      this.rawPlayer.pause();
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      var _this$rawPlayer2 = this.rawPlayer,
        videoWidth = _this$rawPlayer2.videoWidth,
        videoHeight = _this$rawPlayer2.videoHeight;

      // Video may not be playing so these may be 0
      if (videoHeight && videoWidth) {
        return videoWidth / videoHeight;
      }

      // If above is 0, fetch first height/width
      if (this._qualities.normalised.length > 0) {
        var _this$_qualities$norm = this._qualities.normalised[0],
          width = _this$_qualities$norm.width,
          height = _this$_qualities$norm.height;
        if (width && height) {
          return width / height;
        }
      }
      return 16 / 9;
    }
  }, {
    key: "autoAdvance",
    get: function get() {
      return this._autoAdvance;
    },
    set: function set(a) {
      this._autoAdvance = a;
    }
  }, {
    key: "autoplay",
    get: function get() {
      return this.rawPlayer.autoplay;
    },
    set: function set(a) {
      this.rawPlayer.autoplay = a;
    }
  }, {
    key: "autoPlayClips",
    get: function get() {
      return this._autoPlayClips;
    },
    set: function set(a) {
      this._autoPlayClips = a;
    }
  }, {
    key: "buffered",
    get: function get() {
      return this.rawPlayer.buffered;
    }
  }, {
    key: "currentFrame",
    get: function get() {
      if (!this.canSeekByFrame) {
        return null;
      }
      var activeQuality = this.rawPlayer.videoTracks.item(0).activeQuality;
      return Math.round((this.rawPlayer.currentTime - activeQuality.firstFrame) * activeQuality.frameRate - 0.5);
    },
    set: function set(f) {
      if (!this.canSeekByFrame) {
        return;
      }
      var activeQuality = this.rawPlayer.videoTracks.item(0).activeQuality;
      this.rawPlayer.currentTime = (f + 0.5) / activeQuality.frameRate + activeQuality.firstFrame;
    }
  }, {
    key: "currentSrc",
    get: function get() {
      if (!(this.rawPlayer && this.rawPlayer.source && this.rawPlayer.sources)) {
        return null;
      }
      return Array.isArray(this.rawPlayer.source.sources) ? this.rawPlayer.source.sources[0].src : this.rawPlayer.source.sources.src;
    }
  }, {
    key: "currentTime",
    get: function get() {
      return _VideoTimeHelpers["default"].getCurrentTime(this.currentPlayable, this.rawPlayer.currentTime);
    },
    set: function set(t) {
      if (!this.currentPlayable) return;
      var time = (this.currentPlayable.startTime || 0) + t;
      // Only set on rawPlayer if the value is different. Spamming this while seeking mp4s has
      // historically contributed to the underlying player getting stuck in a seeking state.
      if (this.rawPlayer.currentTime !== time) {
        this.rawPlayer.currentTime = time;
      }
    }
  }, {
    key: "duration",
    get: function get() {
      if (!this.currentPlayable) return 0;
      var duration = this.rawPlayer.duration;
      if (duration === Infinity) {
        var _this$rawPlayer$seeka;
        if (!((_this$rawPlayer$seeka = this.rawPlayer.seekable) !== null && _this$rawPlayer$seeka !== void 0 && _this$rawPlayer$seeka.length) || this.rawPlayer.readyState < 1) return 0;
        duration = this.rawPlayer.seekable.end(this.rawPlayer.seekable.length - 1);
      }
      return _VideoTimeHelpers["default"].getDuration(this.currentPlayable, duration);
    }
  }, {
    key: "_rawDuration",
    get: function get() {
      return this.rawPlayer.duration;
    }
  }, {
    key: "ended",
    get: function get() {
      return this.rawPlayer.ended;
    }
  }, {
    key: "error",
    get: function get() {
      return this.rawPlayer.error;
    }
  }, {
    key: "initialized",
    get: function get() {
      return this._playerState.initialized;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.rawPlayer.muted;
    },
    set: function set(m) {
      this.rawPlayer.muted = m;
    }
  }, {
    key: "paused",
    get: function get() {
      return this.rawPlayer.paused && !this._rewind.interval;
    }
  }, {
    key: "seeking",
    get: function get() {
      return this.rawPlayer.seeking && !this.rewinding;
    }
  }, {
    key: "src",
    get: function get() {
      return this.rawPlayer.src;
    },
    set: function set(s) {
      var _this5 = this;
      this.updateYouboraOptionsForCurrentPlayable();
      this._playerState.autoQuality = (0, _QualityUtils.isHLS)(s);
      var contentType = undefined;
      if ((0, _QualityUtils.isHLS)(s)) {
        contentType = CONTENT_TYPE_HLS;
      } else if ((0, _QualityUtils.isMP4)(s)) {
        contentType = CONTENT_TYPE_MP4;
      }
      this._setHideSpinnerClass(true);
      this._preloader.getPreloadedFile(s, function (srcUri, wasFilePreloaded) {
        // show spinner when starting a non-preloaded clip
        if (!wasFilePreloaded) {
          // show the spinner for non-preloaded clips, because they'll take a little longer to load
          // allow a slight delay before showing the spinner, because if the clip is in the browser cache,
          // it'll be almost-instantaneous and we also don't want to show the spinner then
          if (!_this5._isPlayableDynamic) {
            setTimeout(function () {
              _this5._setHideSpinnerClass(false);
            }, 100);
          }
        }
        _this5.updatePlayerSource(srcUri, contentType);
      });
    }
  }, {
    key: "setStartTimeForPlayable",
    value: function setStartTimeForPlayable() {
      var playable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentPlayable;
      var playableDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.duration;
      if (this._trySeekingToEnd(playable, playableDuration)) {
        return;
      }
      if (this._tryUsingSkipToTime(playable, playableDuration)) {
        return;
      }
      if (this._trySkipResettingCurrentTime(playable)) {
        return;
      }
      this.currentTime = 0;
    }
  }, {
    key: "_trySeekingToEnd",
    value: function _trySeekingToEnd(playable, playableDuration) {
      // If _playableSeekingType is set to end for the current playable, seek to the end of the video
      if (playable && this._dynamicSeekingEdgeState === 'end' && playableDuration) {
        this.currentTime = playableDuration;
        return true;
      }
      return false;
    }
  }, {
    key: "_tryUsingSkipToTime",
    value: function _tryUsingSkipToTime(playable, playableDuration) {
      // If skipToTime is set for the current playable and less than its duration, skip ahead to that point in the video
      // The duration will not be correct for the current playable until the readyState is > 0
      // See https://docs.theoplayer.com/api-reference/web/theoplayer.chromelessplayer.md#readystate
      if (playable && playable.skipToTime && playableDuration && this.rawPlayer.readyState > 0 && playable.skipToTime < playableDuration) {
        this.currentTime = playable.skipToTime;
        return true;
      }
      return false;
    }
  }, {
    key: "_trySkipResettingCurrentTime",
    value: function _trySkipResettingCurrentTime(playable) {
      // If the player is transitioning between consecutive playables (same source stream, consecutive indices in playables
      // list), only adjust the current time if it is outside the bounds of the new playable. This option must explicitly
      // be opted in via a property on the playable. This is to support loading a playlist of virtual clips from the same video
      // where clips may have overlapping timeframes, without **any** interruption in video playback. This option is not
      // compatible with the skipToTime option, because it doesn't produce frame-precise video and audio playback.

      // Behavior is opt-in with explicit `true` value
      if ((playable === null || playable === void 0 ? void 0 : playable.skipCurrentTimeUpdatesBetweenConsecutivePlayables) !== true) {
        return false;
      }

      // The duration will not be correct for the current playable until the readyState is > 0
      var readyState = this.rawPlayer.readyState;
      if (readyState === 0) {
        return false;
      }

      // Ensure this is a transition between consecutive clips
      var previousIndex = this._playables.previousIndex;
      if (previousIndex === undefined || playable.src === this._previousPlayable.src && playable !== this._playables.sources[previousIndex + 1]) {
        return false;
      }

      // Ensure current time is within playable timeframe
      var rawCurrentTime = this.rawPlayer.currentTime;
      if (rawCurrentTime < playable.startTime || rawCurrentTime > playable.endTime) {
        return false;
      }
      return true;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.rawPlayer.volume;
    },
    set: function set(v) {
      var newVolume = Math.min(1, Math.max(0, v));
      this.rawPlayer.volume = newVolume;
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this._rewind.rate !== null ? -this._rewind.rate : this.rawPlayer.playbackRate;
    },
    set: function set(rate) {
      var isDirectionChange = rate > 0 && this._rewind.rate !== null || rate < 0 && this._rewind.rate === null;
      if (rate < 0) {
        this._rewind.rate = -rate;
      } else {
        this._rewind.rate = null;
        this.rawPlayer.playbackRate = rate;
      }
      this._playerState.playStartClockTime = 0;
      if (isDirectionChange && !this.paused) {
        this.play();
      }
    }
  }, {
    key: "width",
    get: function get() {
      return this.getVideoContainer().clientWidth;
    },
    set: function set(w) {
      if (typeof w === 'number') {
        this.getVideoContainer().style.width = w + 'px';
      }
    }
  }, {
    key: "height",
    get: function get() {
      return this.getVideoContainer().clientHeight;
    },
    set: function set(h) {
      if (typeof h === 'number') {
        this.getVideoContainer().style.height = h + 'px';
      }
    }
  }, {
    key: "canPlaySlowBackward",
    get: function get() {
      // SlowBackward can be simulated through repeated seeking
      return true;
    }
  }, {
    key: "canPlayFastBackward",
    get: function get() {
      // FastBackward can be simulated through repeated seeking
      return true;
    }
  }, {
    key: "canPlaySlowForward",
    get: function get() {
      return true;
    }
  }, {
    key: "canPlayFastForward",
    get: function get() {
      return true;
    }
  }, {
    key: "currentQuality",
    get: function get() {
      if (this._qualities.normalised.length === 0) {
        return null;
      }

      // THEO provides the currently played quality, regardless if it is AUTO mode
      var keyComponent = this._playerState.autoQuality ? _QualityUtils.AUTO_LABEL : this.rawPlayer.videoTracks.item(0).activeQuality.height;
      var key = (0, _QualityUtils.generateQualityKey)(this.src, keyComponent);
      var normalised = Object.assign({}, this._qualities.normalised.find(function (n) {
        return n.key === key;
      }));
      if (this._playerState.autoQuality) {
        var activeQuality = this.rawPlayer.videoTracks.item(0).activeQuality;
        if (activeQuality) {
          normalised.width = activeQuality.width;
          normalised.height = activeQuality.height;
          normalised.label = "".concat(_QualityUtils.AUTO_LABEL, " (").concat((0, _QualityUtils.heightToLabel)(activeQuality.height), ")");
        }
      }
      return normalised;
    },
    set: function set(q) {
      if (this._qualities.normalised.length === 0) {
        return;
      } else if (!q.key) {
        this._warnUsage('Setting a quality without a key');
      }
      var nativeQuality = this._qualities["native"][q.key];
      var activeQuality = this.rawPlayer.videoTracks.item(0).activeQuality;
      var playingHeight = activeQuality && activeQuality.height;
      var nextHeight = nativeQuality && nativeQuality.height || -1;

      // Set whether player quality is changing to AUTO
      this._playerState.autoQuality = q.key === (0, _QualityUtils.generateQualityKey)(this.src, _QualityUtils.AUTO_LABEL);
      if (this._playerState.autoQuality) {
        this.rawPlayer.videoTracks.item(0).targetQuality = undefined;
      } else {
        this._setTargetQuality(q);
      }
      if (this._playerState.autoQuality || nextHeight === playingHeight) {
        this.emit(EVENTS.QUALITYCHANGED);
      }
    }
  }, {
    key: "_setTargetQuality",
    value: function _setTargetQuality(q) {
      if (!q.key) {
        this._warnUsage('Setting a quality without a key');
      }
      var videoTrack = this.rawPlayer.videoTracks.item(0);
      if (videoTrack && videoTrack.qualities) {
        var nativeQuality = this._qualities["native"][q.key];
        var targetQuality = nativeQuality && videoTrack.qualities.find(function (n) {
          return n.id === nativeQuality.id;
        });
        videoTrack.targetQuality = targetQuality || undefined;
      }
    }
  }, {
    key: "resetAutoTargetQuality",
    value: function resetAutoTargetQuality() {
      clearTimeout(this._resetAutoTargetQualityTimeout);
      var autoQualityKey = (0, _QualityUtils.generateQualityKey)(this.src, _QualityUtils.AUTO_LABEL);
      var autoQuality = Object.assign({}, this._qualities.normalised.find(function (n) {
        return n.key === autoQualityKey;
      }));
      if (autoQuality.key) {
        this._setTargetQuality(autoQuality);
      }
    }
  }, {
    key: "qualities",
    get: function get() {
      return this._qualities.normalised;
    }
  }, {
    key: "canSeekByFrame",
    get: function get() {
      // See https://support.theoplayer.com/hc/en-us/articles/360000785305-Frame-accurate-seeking-migration-from-THEOplayer-1-X-to-2-X
      var activeQuality = this.rawPlayer.videoTracks && this.rawPlayer.videoTracks.item(0) && this.rawPlayer.videoTracks.item(0).activeQuality;
      return !!activeQuality && !!activeQuality.frameRate && (!!activeQuality.firstFrame || activeQuality.firstFrame === 0);
    }
  }, {
    key: "live",
    get: function get() {
      return this.rawPlayer && this.rawPlayer.duration === Infinity;
    }
  }, {
    key: "_hasBufferForRewind",
    value:
    /**
     * Checks if we have video buffered for the given time. The time provided must be
     * actual player time, not time relative to playable start time (like this.currentTime is).
     */
    function _hasBufferForRewind(rawCurrentTime) {
      var buffered = this.rawPlayer.buffered;
      for (var i = 0; i < buffered.length; i++) {
        if (buffered.start(i) <= rawCurrentTime && buffered.end(i) >= rawCurrentTime) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_startRewinding",
    value: function _startRewinding() {
      var _this6 = this;
      if (this._rewind.interval) {
        return;
      }
      var currentTime = this.currentTime;
      // setup once-per-rewind variables
      this._rewind = _objectSpread(_objectSpread({}, this._rewind), {}, {
        lastPlayerTime: 0,
        oldSeekTime: currentTime,
        newSeekTime: currentTime,
        logged: false,
        initialStep: true,
        startTime: currentTime,
        // used for logging
        playableStartTime: _VideoTimeHelpers["default"].getStartTime(this.currentPlayable)
      });
      this.rawPlayer.pause();
      // Using setInterval as renderAnimationFrame does not work well with Theo
      // This simulates a playback rate of 12.5fps (80ms per frame)
      var INTERVAL_RATE = 80;
      this._rewind.interval = setInterval(function () {
        return _this6._doRewindStep();
      }, INTERVAL_RATE);
    }
  }, {
    key: "_stopRewinding",
    value: function _stopRewinding() {
      if (this._rewind.interval) {
        this.hideSpinner = false;
        clearInterval(this._rewind.interval);
        this._rewind.interval = null;
      }
    }
  }, {
    key: "playingIndex",
    get: function get() {
      return this._playables.index;
    },
    set: function set(index) {
      // Update the previous index even if the new index is the same to ensure user
      // actions that reload the same index don't throw off this tracking.
      this._playables.previousIndex = this._playables.index;
      if (index === this._playables.index) {
        this.setStartTimeForPlayable();
        this.emit(EVENTS.TIMEUPDATE);
        return;
      }

      // cancel in-progress preloads if seeking backwards to prevent buffering problems
      if (index < this._playables.index) {
        this._preloader.abortCurrentPreloadRequest();
      }
      this._playables.index = index;
      this.updateYouboraOptionsForCurrentPlayable();

      // Stop the activity tracker if necessary to capture previous playable context
      // in a heartbeat before changing the index and updating the time.
      // play() will restart the heartbeat.
      _ActivityTrackingUtils.videoTrackingStop.call(this);
      if (this.currentPlayable) {
        this.src = this.currentPlayable.src;
      }
      if (this._autoPlayClips) {
        this.play();
      }
      this.emit(EVENTS.TIMEUPDATE);
      _listeners.onPlaylistItem.call(this, {
        index: index
      });
    }
  }, {
    key: "playables",
    get: function get() {
      var playables = _toConsumableArray(this._playables.sources);
      playables.insert = this._insert;
      playables.remove = this._remove;
      playables.push = this._push;
      return playables;
    },
    set: function set(playables) {
      var _playables$;
      this._playables = {
        sources: (0, _extractPlayablesFromConfig["default"])(playables, window.location, _AdUtils.getPlayableAds),
        index: 0,
        previousIndex: undefined,
        selectedAngleName: (_playables$ = playables[0]) === null || _playables$ === void 0 ? void 0 : _playables$.selectedAngleName
      };
      this._preloader.setPlayables(this._playables.sources);
      if (!this._playerState.initialized) {
        return;
      }
      this.updateYouboraOptionsForCurrentPlayable();
      this.src = this.currentPlayable.src;
      this.play();
      if (!this.autoplay || this._dynamicSeekingEdgeState) {
        this.pause();
      }
      _listeners.onPlaylistItem.call(this, {
        index: 0
      });
    }
  }, {
    key: "currentPlayable",
    get: function get() {
      return this._playables.sources[this._playables.index];
    }
  }, {
    key: "_previousPlayable",
    get: function get() {
      return this._playables.previousIndex === undefined ? undefined : this._playables.sources[this._playables.previousIndex];
    }
  }, {
    key: "_dynamicSeekingEdgeState",
    get: function get() {
      return this.currentPlayable && this.currentPlayable.dynamicSeekingEdgeState;
    }
  }, {
    key: "_isPlayableDynamic",
    get: function get() {
      return this.currentPlayable && this.currentPlayable.isDynamic;
    }
  }, {
    key: "updateYouboraOptionsForCurrentPlayable",
    value: function updateYouboraOptionsForCurrentPlayable() {
      var _this$_playables$sele, _this$_playables, _this$currentPlayable;
      if (!this._youboraPlugin) {
        return;
      }
      var src = this.currentPlayable && this.currentPlayable.src || this.currentSrc;
      var options = {
        'content.title': src,
        'content.resource': src,
        'content.isLive': this.live,
        'content.duration': this.duration,
        'content.customDimension.4': (_this$_playables$sele = (_this$_playables = this._playables) === null || _this$_playables === void 0 ? void 0 : _this$_playables.selectedAngleName) !== null && _this$_playables$sele !== void 0 ? _this$_playables$sele : (_this$currentPlayable = this.currentPlayable) === null || _this$currentPlayable === void 0 ? void 0 : _this$currentPlayable.selectedAngleName
      };
      this._youboraPlugin.setOptions(options);
    }

    /**
     * @param {boolean} hide
     */
  }, {
    key: "hideSpinner",
    set: function set(hide) {
      this._playerState.hideSpinner = hide;
      this._setHideSpinnerClass(hide);
    }

    /**
     * @param {boolean} hide
     */
  }, {
    key: "_setHideSpinnerClass",
    value: function _setHideSpinnerClass(hide) {
      var container = this.getVideoContainer().parentElement;
      if (!container) {
        return;
      }
      var classIndex = container.className.indexOf('vjs-hide-spinner');
      if (hide && classIndex === -1) {
        container.className += ' vjs-hide-spinner';
      } else if (!hide && classIndex !== -1) {
        container.className = container.className.replace(' vjs-hide-spinner', '');
      }
    }

    /**
     * @param {int} delay
     * Hides the spinner for the length of the delay (in ms)
     * if the `hideSpinner` prop is set and the player is rewinding.
     */
  }, {
    key: "_showSpinnerWithDelay",
    value: function _showSpinnerWithDelay() {
      var _this7 = this;
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
      if (this._playerState && this._playerState.hideSpinner && !(this._rewind && this._rewind.oldSeekTime === this._rewind.newSeekTime)) {
        clearTimeout(this._hideSpinnerInterval);
        this._setHideSpinnerClass(true);
        this._hideSpinnerInterval = setTimeout(function () {
          return _this7._setHideSpinnerClass(false);
        }, delay);
      }
    }

    /**
     * Hides the spinner without a delay
     * if the `hideSpinner` prop is set and the player is rewinding.
     */
  }, {
    key: "_hideSpinnerClearDelay",
    value: function _hideSpinnerClearDelay() {
      if (this._playerState && this._playerState.hideSpinner && !(this._rewind && this._rewind.oldSeekTime === this._rewind.newSeekTime)) {
        clearTimeout(this._hideSpinnerInterval);
        this._hideSpinnerInterval = null;
        this._setHideSpinnerClass(true);
      }
    }
  }]);
}(_BasePlayer2["default"]);